import type { TimeControl } from '../../shared/protocol.ts';
import type { Translate } from '../app/preferences.ts';

/** "5 min +3 sec" instead of the chess shorthand "5+3". */
export function timeControlText(tc: TimeControl | null, t: Translate): string {
  if (!tc) return t('time.unlimited');
  const minutes = t('time.minutes', { n: tc.initialMs / 60_000 });
  return tc.incrementMs > 0 ? `${minutes} ${t('time.incrementShort', { n: tc.incrementMs / 1000 })}` : minutes;
}
